const callCustomSignAction = (siteId, url) => {
	const rules = {
		'4253200': () => {
			if (window.opener) {
				window.opener.top.postMessage('login', '*');
				window.close();	
			} else {
				window.top.parent.postMessage('login', '*');
			}
		},
		'4270400': () => {
			const message = {
				type: 'loginNeed',
			};

			if (window.parent) {
				window.parent.postMessage(JSON.stringify(message), '*');
			}

			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(JSON.stringify(message), '*');
			}
		},
		default: () => {
			location.href = url;
		}
	};

	rules[siteId] ? rules[siteId]() : rules.default();
};

export const siteService = {
	callCustomSignAction
};